import React, { useEffect, useState } from "react";
import {
  IonPage,
  IonContent,
  IonCard,
  IonCardContent,
  IonButton,
  IonLabel,
  IonRadioGroup,
  IonRadio,
  IonItem,
  IonList,
} from "@ionic/react";

interface QuestionData {
  sentence: string;
  options: string[];
  correctAnswer: string;
}


const MeasuringLiquid: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [questions, setQuestions] = useState<QuestionData[]>([]);

    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };

    const handleSubmit = (option: React.SetStateAction<string | null>) => {
        setSelectedOption(option);
        const currentQuestion = questions[currentIndex];
        if (option === currentQuestion.correctAnswer) {
            // Automatically move to the next question
            setShowImage(true);
            setTimeout(() => {
                if (currentIndex != questions.length - 1) {
                    setCurrentIndex(currentIndex + 1);
                }
                else {
                    setCurrentIndex(0);
                    fetchQuestions();
                }
                setShowImage(false);
                setSelectedOption(null);
            }, 5000); // Delay reduced to 3 seconds
        }
    };

    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'MeasuringLiquid.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/MeasuringLiquid.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };

    useEffect(() => {
        fetchQuestions();
        document.title = "Mamas Guidance - Class One - Mathematics - Measurement - Liquid"; // Set page title
    }, []);

  return (
    <>
        {showImage === false ? (
            <>
                <div className="contentPart showCenter fillPreposition additionWord">
                    {/* <h2>Fill in the Blanks with Correct Options</h2>
                    <p>Choose the correct answer to complete the sentence:</p> */}
            
                    <p>
                        <strong>
                            Q. {questions[currentIndex]?.sentence}
                        </strong>
                    </p>
                    <IonRadioGroup
                    value={selectedOption}
                    onIonChange={(e) => handleSubmit(e.detail.value)}
                    >
                        {questions[currentIndex]?.options.map((option, index) => (
                            <IonItem style={{ width: 'auto', fontSize: '20px' }}
                                className={`grid-item ${
                                    selectedOption === option
                                    ? option === questions[currentIndex]?.correctAnswer
                                        ? "correct"
                                        : "errorItems"
                                    : ""
                                }`}
                                key={index}>
                            <IonRadio slot="start" value={option} />
                            <IonLabel>{option}</IonLabel>
                        </IonItem>
                        ))}
                    </IonRadioGroup>
                </div>
            </>
            ) : (
            <>
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: "150px" }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK}
                    />
                </div>
            </>
            )}
        </>
    );
};

export default MeasuringLiquid;
